import axios from 'axios';

// GET /admin/candidates -> [{ id (candidateId), email, name, sponsor, status, ... }].
// Used to resolve a user's candidateId (by email) for Resend Invite, since GET /users has none.
export async function getAdminCandidates() {
  try {
    const res = await axios.get('/admin/candidates');
    return (res.data && res.data.candidates) || [];
  } catch (error) {
    console.error(error);
    return [];
  }
}
